const pxRegex = /(\d+)px/
export const getNumbersInPxString = (pixelString: string): number =>
  Number(pixelString.match(pxRegex)[1])
